import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { INTEGRATIONCONNECTIONS } from '../../../../constants/applicationConstants';
import {
  DataTableHoc,
  Loader,
  ErrorFallback,
  deleteFilter,
  applyFilter,
  saveFilters,
} from 'smart-react';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../../constants/applicationConstants';
const BaseDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable'),
);
const ConnectionDataTable = DataTableHoc(BaseDataTable);

/**
 * IntegrationConnection main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The IntegrationConnection component.
 */
const IntegrationConnection = ({ integrationSystem }) => {
  const [userData, setUserData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className='container mx-auto k-px-4'>
        <React.Suspense fallback={<Loader />}>
          <ConnectionDataTable
            integrationSystem={integrationSystem}
            deleteFilter={deleteFilter}
            applyFilter={applyFilter}
            saveFilters={saveFilters}
            moduleName={INTEGRATIONCONNECTIONS}
            dataColumns={dataColumnsArray}
            gridColumnsList={GridColumnsList}
            dataTableName={INTEGRATIONCONNECTIONS}
            setIsReady={setIsReady}
            isReady={isReady}
            rowLayoutConfigName={`${INTEGRATIONCONNECTIONS}.DataGrid.RowLayout`}
            pageLengthConfigName={`${INTEGRATIONCONNECTIONS}.DataGrid.ItemsPerPage`}
            dataSet={userData}
            setDataSet={setUserData}
            initialSort={{
              field: 'id',
              dir: 'desc',
            }}
            isCardonMobileView={false}
            total={process.env.DefaultLimit}
            defaultRowLayout={process.env.RowLayout}
            rowLayouts={ROW_LAYOUTS}
            pageSizes={PAGE_SIZE}
            isDefaultSlider={true}
            contentSliderTitle={'Integration Connection'}
          />
        </React.Suspense>
      </div>
    </ErrorBoundary>
  );
};
export default IntegrationConnection;
